import React, { useState, useEffect, useRef } from "react";
import { Clock, ArrowRight, CheckCircle, X, Calendar, Trash2 } from "lucide-react";
import { format } from "date-fns";
import Moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { toast } from 'react-hot-toast';
import {
  fetchBookingDetails, selectBookingDetails, selectBookingDetailsStatus, GETAmendmentCharges, SubmitAmendmentCharges
} from "./flightSlice";
import { selectCurrentUser } from "../auth/authSlice";
import ItineraryLoader from "../../components/ItineraryLoader";
import { DateInput } from "@mantine/dates";
import { Dialog } from "@headlessui/react";
import useDocumentTitle from "../../hooks/useDocumentTitle";
import CheckboxGroup from "./CheckboxGroup";
import CurFt from "../../components/CurFt";

export default function Amendment() {
  useDocumentTitle('Booking Amendment');
  const { BookingID } = useParams()
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const requestTypes = (params?.get("requestTypes") || '');

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const BookingDetails = useSelector(selectBookingDetails);
  const BookingDetailsStatus = useSelector(selectBookingDetailsStatus);
  const user = useSelector(selectCurrentUser)

  const [BookingData, setBookingData] = useState([]);
  const [fare, setfare] = useState([]);
  const [isSectorModalOpen, setIsModalSector] = useState(false);
  const [loading, setloading] = useState(false)

  const [currency, setCurrency] = useState({
    CurrencyRate: "1",
    CurrencyTitle: "INR",
    CurrencyId: 1,
  }); // 15 min session


  useEffect(() => {
    if (BookingID && currency) {
      dispatch(fetchBookingDetails({ BookingID, currency }));
    }
  }, [BookingID, dispatch]);

  const validationData = BookingDetails || {};
  const validationStatus = BookingDetailsStatus || "idle";


  const isLoading = validationStatus === "loading";
  useEffect(() => {
    if (validationStatus === "succeeded" && validationData) {
      const data = validationData.data
      if (validationData.status.success) {
        setBookingData(data.BookingDetails)
        setfare(data.fare)
      } else {
        toast.error(data.message, { autoClose: 2000 });
      }
    } else if (validationStatus === "failed") {
      toast.error('Request longer available.Please try again', { autoClose: 2000 });
    }
  }, [validationStatus, validationData]);

  const [Processing, setProcessing] = useState(false);

  const renderRadio = (value, title, desc) => (
    <label
      className={`flex items-start gap-3 p-3 rounded-md cursor-pointer ${selectedReason === value ? "bg-orange-50" : ""
        }`}
    >
      <input
        type="radio"
        name="cancelReason"
        value={value}
        checked={selectedReason === value}
        onChange={() => handleChange(value)}
        className="mt-1 accent-orange-600"
      />
      <div>
        <div className="font-semibold">{title}</div>
        {desc && <div className="text-gray-600 text-sm">{desc}</div>}
      </div>
    </label>
  );

  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [trips, setTrips] = useState([]);
  const [selectedReason, setSelectedReason] = useState("");
  const [requestType, setrequestType] = useState(requestTypes);
  const [Remarks, setRemarks] = useState("");

  const handleChangeRemarks = (e) => {
    setRemarks(e.target.value)
  };
  const handleChangeType = (e) => {
    setrequestType(e.target.value)
    if (e.target.value === '14') {
      setIsModalSector(true)
    }
  };

  const handleChange = (value) => {
    setSelectedReason(value);
  };
  const handleClose = () => {
    setSubmitButton(false)
  };
  const [submitbutton, setSubmitButton] = useState(false);
  const [refundTotalAmount, setrefundTotalAmount] = useState(0);
  const [service_fee, setservice_fee] = useState(0);
  const [service_gst, setservice_gst] = useState(0);
  const [Currncy, setCurrncy] = useState('INR');
  const [Message, setMessage] = useState('');

  const [SelectedItem, setSelectedItem] = useState({});
  const [documents, setDocuments] = useState([]);
  const [isOpenUpload, setIsOpenUpload] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = useRef(null);

  const submit = async (e) => {
    e.preventDefault();
    let savetype = e.nativeEvent.submitter.attributes.savetype.value

    const postData = { selectedCustomer, selectedReason, BookingID, requestType, savetype, Remarks }

    if (savetype === '2' && Remarks === '') {
      toast.error('Select enter Remarks', { autoClose: 2000 });
      return false;
    }
    if (requestType === '') {
      toast.error('Select cancel title', { autoClose: 2000 });
      return false;
    }
    if (selectedCustomer.length === 0) {
      toast.error('Select atleast one passenger', { autoClose: 2000 });
      return false;
    }
    if (selectedReason === '') {
      toast.error('Select atleast one check-list', { autoClose: 2000 });
      return false;
    }
    if (selectedFiles.length === 0 && requestType === '19') {
      toast.error('Please select at least one relevant Document.', { autoClose: 2000 });
      return;
    }
    setProcessing(true)

    if (savetype === '1') {

      const response = await dispatch(
        GETAmendmentCharges({ postData })
      ).unwrap();
      const Resultdata = response.data;
      if (Resultdata.status.success) {
        setTrips(Resultdata.trips)
        setrefundTotalAmount(Resultdata.refundTotalAmount)
        setservice_fee(Resultdata.service_fee)
        setservice_gst(Resultdata.service_gst)
        setCurrncy(Resultdata.Currncy)
        setSubmitButton(true)
        setMessage(Resultdata.message)
      } else {
        toast.error(Resultdata.message, { autoClose: 2000 });
        return false;
      }
      setProcessing(false)
    } else {
      // return false;

      const formData = new FormData();

      Object.entries(postData).forEach(([key, value]) => {
        formData.append(key, value ?? '');
      });

      selectedFiles.forEach((file) => {
        formData.append("documents[]", file);
      });

      const response = await dispatch(
        SubmitAmendmentCharges({ formData })
      ).unwrap();
      const Resultdata = response.data;
      if (Resultdata.status.success) {
        setTimeout(() => {
          toast.success(Resultdata.message, { autoClose: 3000 });
          window.location.href = `/flight/booking-confirmation/${Resultdata.BookingID}`;
        }, 3000);

      } else {
        toast.error(Resultdata.message, { autoClose: 2000 });
        return false;
      }
    }
  }

  const [SearchData, setSearchData] = useState({
    BookingID: BookingID,
    pnr: '',
    passengers: [],
    travelDate: null
  })
  const [SelectedPNR, setSelectedPNR] = useState(null);
  const handleChangeSearch = (eOrName: any, value?: any) => {
    if (typeof eOrName === "string") {
      // Case: custom components like DateInput
      setSearchData((prev) => ({
        ...prev,
        [eOrName]: value,
      }));
    } else {
      // Case: normal <input />, <select />, etc.
      const e = eOrName;
      setSearchData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
    }
  };

  useEffect(() => {
    const filtered = BookingData.filter((item) => item.PNRNumber === SearchData.pnr);
    if (filtered.length) {
      setSelectedPNR(filtered[0]);
    }
  }, [SearchData.pnr]);

  // ✅ Handle single checkbox
  const handleSingleCheck = (passenger, key) => {
    let updated = [...SearchData.passengers];

    const exists = updated.find((p) => p.id === passenger.id);

    if (exists) {
      updated = updated.filter((p) => p.id !== passenger.id);
    } else {
      updated.push({ id: passenger.id, PaxType: passenger.PaxType, index: (key + 1) });
    }

    handleChangeSearch("passengers", updated);
  };

  // ✅ Handle select all
  const handleSelectAll = () => {
    if (SearchData.passengers.length === SelectedPNR?.Travellers.length) {
      handleChangeSearch("passengers", []);
    } else {
      const all = SelectedPNR?.Travellers.map((p) => ({
        id: p.id,
        PaxType: p.PaxType,
      }));
      handleChangeSearch("passengers", all);
    }
  };

  const [date, setDate] = useState(null);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (SearchData.pnr === null || SearchData.pnr === '') {
      toast.error('Select Flight/PNR!', { autoClose: 2000 });
      return;
    }
    if (SearchData.travelDate === null || SearchData.travelDate === '') {
      toast.error('Select New Reschedule date!', { autoClose: 2000 });
      return;
    }
    const passengers = SearchData.passengers || [];
    let selectedPax = passengers.reduce(
      (acc, p) => {
        if (p.type === "A") acc.adult += 1;
        else if (p.type === "C") acc.child += 1;
        else if (p.type === "I") acc.infant += 1;

        return acc;
      },
      { adult: 0, child: 0, infant: 0 }
    );
    // ✅ Check if at least one Adult exists
    const hasAdult = passengers.some((p) => (p.PaxType === "A"));

    if (!hasAdult) {
      toast.error('Re-issue not possible without Adult. Please select at least one Adult.', { autoClose: 2000 });
      return;
    }
    const fullText = SelectedPNR?.FareLists?.FareClass;
    const onlyText = fullText.split(" (")[0];
    const FormData = {
      fromCode: SelectedPNR?.SoCode,
      toCode: SelectedPNR?.DeCode,
      from: SelectedPNR?.SoCity + ' (' + SelectedPNR?.SoCode + ')',
      to: SelectedPNR?.DeCity + ' (' + SelectedPNR?.DeCode + ')',
      interNational: SelectedPNR?.IsInt,
      JourneyType: '1',
      TPSystemID: 0,
      FareTypes: 'REGULAR',
      cabinClass: onlyText,
      departureDate: SearchData.travelDate,
      BookingID: SearchData.BookingID,
      pnr: SearchData.pnr,
      passengers: JSON.stringify(SearchData.passengers),
      ADULT: selectedPax?.adult.toString(),
      CHILD: selectedPax?.child.toString(),
      INFANT: selectedPax?.infant.toString(),
      returnDate: '',
      isDirectFlight: true,
      isConnectingFlight: true,
      requestType: requestType,
    };

    const queryString = new URLSearchParams(FormData).toString();
    navigate(`/flight/reissue/search?${queryString}`);
  };

  const allowedTypes = ["image/jpeg", "image/png", "image/webp", "application/pdf"];

  const validateAndAddFiles = (files) => {
    const validFiles = Array.from(files).filter((file) => {
      if (!allowedTypes.includes(file.type)) {
        alert(`${file.name} is not a valid format. Only Images & PDFs are allowed.`);
        return false;
      }
      return true;
    });

    setSelectedFiles((prev) => [...prev, ...validFiles]);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      validateAndAddFiles(e.dataTransfer.files);
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      validateAndAddFiles(e.target.files);
    }
  };

  const removeSelectedFile = (index) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
  };
  return (
    <>
      {isLoading && BookingData.length === 0 ? (
        <>
          <div className="bg-gray-50 min-h-screen pb-16 mt-2">

            <ItineraryLoader />
          </div>
        </>
      ) : (
        <div className="bg-gray-50 min-h-screen pb-16 ">

          <Dialog
            open={isSectorModalOpen}
            onClose={() => setIsModalSector(false)}
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 "
          >
            <div className="bg-white w-full max-w-3xl rounded-2xl max-h-[90vh] shadow-lg p-6 overflow-y-auto">
              {/* Header Row */}
              <div className="flex items-center justify-between w-full border-b pb-2 mb-4">
                <h2 className="text-lg font-semibold">Reschedule Flight</h2>
                <button
                  onClick={() => setIsModalSector(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <X size={20} />
                </button>
              </div>

              {/* Form */}
              <form className="space-y-4" onSubmit={handleSubmit}>
                <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
                  {/* Payment Mode */}
                  <div className="flex flex-col">
                    <label className="text-sm font-medium mb-1">Select Flight/PNR</label>
                    <select name="pnr" value={SearchData.pnr} onChange={handleChangeSearch} className="w-full border rounded-lg px-3 py-2">
                      <option value="">Select PNR</option>
                      {BookingData.map((item, idx) => (
                        <option key={idx} value={item.PNRNumber}>{item.FlightNumber} - {item.PNRNumber}</option>
                      ))}
                    </select>
                  </div>
                </div>

                {SelectedPNR && (
                  <div className="grid grid-cols-1">
                    <div className="flex items-center justify-between border-t border-b border-dashed py-4">
                      {/* Left Section */}
                      <div className="flex items-center gap-3">
                        {/* Airline Logo */}
                        <div className="w-9 h-9 flex items-center justify-center">
                          <img
                            src={SelectedPNR.logo}
                            alt={SelectedPNR.AirlineName}
                            className="w-9 h-9"
                          />
                        </div>
                        {/* Flight Route */}
                        <div>
                          <p className="font-semibold text-gray-900">
                            {SelectedPNR.SoCity} ({SelectedPNR.SoCode}) - {SelectedPNR.DeCity} ({SelectedPNR.DeCode})
                          </p>
                          <p className="text-sm text-gray-500">
                            {Moment(SelectedPNR.FromUTCTime).format('ddd, MMM Do YYYY h:mm A')}
                          </p>
                        </div>
                      </div>

                      {/* Right Section (Date Picker) */}
                      <div className="w-48">
                        <DateInput
                          valueFormat="DD-MM-YYYY"
                          value={SearchData.travelDate}
                          onChange={(date) => handleChangeSearch("travelDate", date)}
                          minDate={new Date()} // ⬅️ disables past dates
                          placeholder="Select New Date"
                          leftSection={<Calendar className="h-4 w-4 text-gray-500" />}
                          classNames={{
                            input:
                              "w-full border rounded-lg px-3 py-2",
                          }}
                        />
                      </div>
                    </div>

                    <div className="p-2 bg-white w-full">
                      <h2 className="text-lg font-semibold mb-3">Passengers</h2>

                      {/* Select All */}
                      <div className="flex items-center gap-2 mb-3">
                        <input
                          type="checkbox"
                          checked={SearchData.passengers.length === SelectedPNR?.Travellers?.length}
                          onChange={handleSelectAll}
                          className="w-4 h-4"
                        />
                        <span className="text-sm font-medium">Select All</span>
                      </div>

                      {/* Passenger List */}
                      <div className="space-y-2">
                        {SelectedPNR.Travellers && SelectedPNR.Travellers.map((p, key) => {
                          const isChecked = SearchData.passengers.some(
                            (item) => item.id === p.id
                          );
                          return (
                            <div
                              key={p.id}
                              className={`flex items-center justify-between p-3 rounded-lg border ${isChecked ? "bg-gray-50 border-gray-300" : "bg-white"
                                }`}
                            >
                              <div className="flex items-center gap-3">
                                <input
                                  type="checkbox"
                                  checked={isChecked}
                                  onChange={() => handleSingleCheck(p, key)}
                                  className="w-4 h-4"
                                />
                                <span className="text-sm font-medium">{p.title}. {p.fname} {p.lname}</span>
                              </div>

                              <div className="flex items-center gap-2">
                                {/* Type Badge */}
                                <span className="px-3 py-1 text-xs rounded-full bg-gray-100 text-gray-600 border">
                                  {p.PaxType}
                                </span>

                                {/* Status Badge */}
                                <span className="px-3 py-1 text-xs rounded-full bg-green-500 text-white">
                                  {p.status === 1 ? 'CONFIRMED' : 'RE-ISSUE'}
                                </span>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                )}

                {/* Submit */}
                <div className="flex justify-end">
                  <button
                    type="submit"
                    disabled={loading === true}
                    className={`bg-blue-500 text-white px-5 py-2 rounded-md hover:blue-600 transition ${loading === true
                      ? 'bg-gray-400 cursor-not-allowed'
                      : 'bg-blue-500 hover:bg-blue-600'
                      }`}
                  >
                    {loading === true ? (
                      <>
                        Please wait...
                      </>
                    ) : (
                      <>
                        Submit
                      </>

                    )}
                  </button>
                </div>
              </form>
            </div>
          </Dialog>


          <div className="flex flex-col gap-6 max-w-6xl mx-auto px-4">

            <form className="mui-form" onSubmit={submit}>
              <div className="flex-1 space-y-6">

                <div className="bg-white shadow-md rounded-lg p-4 mt-4 w-full ">
                  {/* Header */}
                  <div className="flex items-center justify-between">
                    {(BookingData[0]?.FareLists?.is_flexi === 0 || fare.PendingAmount === 0) && (
                      <span className=" flex items-center gap-1">
                        <select onChange={handleChangeType} value={requestType} id="requestType" name="requestType" className="w-full border rounded-lg px-3 py-2" >
                          <option data-value="" value="">Cancel Type</option>
                          <option data-value="CANCELLATION" value="8">Full Cancellation</option>
                          <option data-value="PARTIAL_CANCELLATION" value="7">Partial Cancellation </option>
                          <option data-value="FULL_REFUND" value="6">Full Refund </option>
                          <option data-value="SSR" value="11">Ssr</option>
                          {/* <option data-value="CANCELLATION_QUOTATION" value="12">Cancellation Quotation</option> Under DGCA Policy*/}
                          {/* <option data-value="REISSUE_QUOTATION" value="13">Reissue Quotation </option> */}
                          {BookingData[0]?.JourneyType === 1 && (
                            <option data-value="REISSUE" value="14">Re-Issue / Reschedule</option>
                          )}

                          {/* <option data-value="FARE_CHANGE" value="15">Fare Change</option> */}
                          {/* <option data-value="MISCELLANEOUS" value="16">Miscellaneous</option> */}
                          <option data-value="NO_SHOW" value="17">No Show</option>
                          <option data-value="VOIDED" value="18">Void/Release PNR</option>
                          <option data-value="CORRECTION" value="19">Correction</option>
                        </select>
                      </span>
                    )}
                    <h3 className="font-semibold">
                      <Step icon={<CheckCircle className="w-5 h-5 text-white" />} title="Booking Success" subtitle={BookingData[0]?.BookingID} active />
                    </h3>
                  </div>
                  {(BookingData[0]?.FareLists?.is_flexi === 0 || fare.PendingAmount === 0) ? (
                    <> <p className="text-sm text-red-500"><b>Note:</b> <span>For partial cancellation, select <b>“Cancellation”</b> from the<b> Cancel Type </b>
                      dropdown and choose the specific customer(s) you want to cancel —
                      this will be also treated as a <b>Partial Cancellation</b>.
                      In Cancellation, you will also get <b>real-time cancellation charges and refund amount.</b></span></p></>
                  ) : (
                    <> <div className="text-sm text-red-500 w-full"><b>Note:</b>
                      <span> Cancellation is not permitted for this BNPL booking. Kindly contact Customer Care for further assistance. </span></div></>
                  )}

                </div>

                {BookingData.map((f, idx) => (
                  <div key={idx} className="bg-white rounded-lg shadow p-4 space-y-4">
                    <div className="flex items-center justify-between">
                      <h3 className="font-semibold">
                        {f.SoCity} → {f.DeCity} &nbsp;
                        <span className="text-sm font-normal text-gray-500">
                          on {format(new Date(f.FromUTCTime), "MMM dd, EEE, HH:mm")}
                        </span>
                      </h3>

                      {f.is_amendments === 1 ? (
                        <span className="text-1 text-red-600 flex items-center gap-1">
                          {f.CurrentStatus}
                        </span>
                      ) : (
                        <span className="text-1 text-gray-500 flex items-center gap-1">
                          {f.CurrentStatus}
                        </span>
                      )}
                      <span className="text-sm text-gray-500 flex items-center gap-1">
                        <Clock className="w-4 h-4" /> {f.Duration}
                      </span>
                    </div>

                    {f.Segments.map((SegItem, Segkey) => (
                      <div key={Segkey}>
                        <div className="flex items-start gap-4 rounded-lg bg-white">
                          {/* Airline Logo + Name */}
                          <div className="w-1/5 flex items-center gap-3">
                            <div className="w-12 h-12 rounded-md overflow-hidden bg-gray-100 flex items-center justify-center p-1">
                              <img
                                src={SegItem.filePath}
                                alt={SegItem.AirlineName}
                                className="object-contain w-full h-full"
                              />
                            </div>
                            <div>
                              <div className="font-semibold">
                                {SegItem.AirlineName} &nbsp;
                                <div className="text-gray-500">{SegItem.FlightNumber}</div>
                              </div>
                            </div>
                          </div>

                          {/* Origin */}
                          <div className="w-1/5">
                            <p className="font-bold">
                              {format(new Date(SegItem.originDepTime), "MMM dd, EEE, HH:mm")}
                            </p>
                            <p className="text-sm text-gray-600">
                              {SegItem.originCityName}, {SegItem.originCountryName}
                            </p>
                            <p className="text-sm text-gray-600">{SegItem.originAirportName}</p>
                            <p className="text-xs text-gray-400">Terminal {SegItem.DepTerminal}</p>
                          </div>

                          {/* Arrow (centered) */}
                          <div className="w-1/5 flex items-center justify-center">
                            <ArrowRight className="w-7 h-7 text-gray-400" />
                          </div>

                          {/* Destination */}
                          <div className="w-1/5">
                            <p className="font-bold">
                              {format(new Date(SegItem.destinationArrTime), "MMM dd, EEE, HH:mm")}
                            </p>
                            <p className="text-sm text-gray-600">
                              {SegItem.destinationCityName}, {SegItem.destinationCountryName}
                            </p>
                            <p className="text-sm text-gray-600">{SegItem.destinationAirportName}</p>
                            <p className="text-xs text-gray-400">Terminal {SegItem.ArrTerminal}</p>
                          </div>

                          {/* Duration & Fare Info */}
                          <div className="w-1/5">
                            <p className="font-bold">{SegItem.FlightDuration}</p>
                            <p className="text-sm text-gray-600">{f.FareLists.FareClass}</p>
                            <p className="text-sm text-red-600">{f.FareLists.fareIdentifier}</p>
                            <p className="text-xs text-gray-400">{f.FareLists.RefundableTxt}</p>
                          </div>
                        </div>



                        {/* Layover (if not last segment) */}
                        {SegItem.GroundTime > 0 && (
                          <div className="text-center my-4">
                            <span className="bg-blue-500 text-white text-xs px-3 py-1 rounded-full font-medium">
                              Change Plane at {SegItem.LAYOVERCity}, Layover Time : {SegItem.LAYOVERDuration}
                            </span>
                          </div>
                        )}

                        <div className="text-sm text-gray-600 border-b pt-2 pb-2">
                          <p>
                            🧳 (Adult) Check-in:{f.FareLists.Checkin} Cabin: {f.FareLists.Cabin}
                          </p>
                        </div>
                      </div>
                    ))}

                    <CheckboxGroup items={f.Travellers} setSelectedCustomer={setSelectedCustomer} requestType={requestType} />
                  </div>
                ))}

                {(BookingData[0]?.FareLists?.is_flexi === 0 || fare.PendingAmount === 0) && (
                  <>
                    <div className="bg-white shadow-md rounded p-3 confirm-details mt-2">
                      <h3 className=" mb-3 font-semibold text-white font-semibold bg-blue-500 rounded p-3 ">
                        &nbsp;Select Cancellation Reason From Below
                      </h3>

                      <hr className=" mb-2 mx-n3" />

                      <div className="space-y-4 ">
                        {/* Normal Cancellations */}
                        {(requestType === '14') && (
                          <div className="border rounded-md p-2">
                            <h2 className="text-orange-600 font-semibold mb-2">REISSUE</h2>
                            <div className="grid md:grid-cols-2 xl:grid-cols-2 gap-2">
                              {renderRadio(
                                "FLIGHT_NOT_FOUND",
                                "Flight not found",
                                "Flight not found."
                              )}
                              {renderRadio(
                                "LOW_FARE",
                                "Low fare not found",
                                "Low fare not found."
                              )}
                              {renderRadio(
                                "INCORRECT_REISSUE",
                                "Incorrect reissue fee",
                                "Incorrect reissue fee."
                              )}
                              {renderRadio(
                                "NO_RESULT",
                                "No result found",
                                "No result found."
                              )}
                              {renderRadio(
                                "REASON_NOT_LISTED",
                                "Reason not listed",
                                "Reason not listed."
                              )}
                            </div>
                          </div>
                        )}
                        {(requestType === '8' || requestType === '7') && (
                          <div className="border rounded-md p-2">
                            <h2 className="text-orange-600 font-semibold mb-2">Normal Cancellations</h2>
                            <div className="grid md:grid-cols-2 xl:grid-cols-2 gap-2">
                              {renderRadio(
                                "normal_cancelled",
                                "Travel Plan is Cancelled (Normal Cancellation)",
                                "Change in travel plans. Airline charges will apply as per standard airline cancellation policy."
                              )}
                              {renderRadio(
                                "airline_processed",
                                "Airline confirmed, refund is already processed",
                                "You have already cancelled your booking offline by directly contacting airline - Company to credit the refund."
                              )}
                            </div>
                          </div>
                        )}


                        {/* Full Refund Cancellations */}
                        {requestType === '6' && (
                          <div className="border rounded-md p-2">
                            <h2 className="text-orange-600 font-semibold mb-2">Full Refund Cancellations</h2>
                            <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
                              {renderRadio(
                                "flight_cancelled",
                                "Flight cancelled by the airline, process full refund",
                                "Airline cancelled the flight, eligible for full refund as per airline policy."
                              )}
                              {renderRadio(
                                "timing_changed",
                                "Airline changed the flight timing, process full refund",
                                "Eligible for full refund as per Airline Policy. (e.g., 10AM → 6PM)."
                              )}
                              {renderRadio("dgca_policy", "Process full refund under DGCA airline policy", "Please contact our support team.")}
                              {renderRadio(
                                "airline_confirmed_refund",
                                "Airline confirmed, refund is already processed",
                                "Airline has confirmed and processed full refund to Company."
                              )}
                            </div>
                          </div>
                        )}

                        {/* Void Booking */}
                        {requestType === '18' && (
                          <div className="border rounded-md p-2">
                            <h2 className="text-orange-600 font-semibold mb-2">Void Booking</h2>
                            {renderRadio("void", "Void this booking, process full refund")}
                          </div>
                        )}

                        {/* No Show Booking */}
                        {(requestType === '8' || requestType === '7' || requestType === '17') && (
                          <div className="border rounded-md p-4">
                            <h2 className="text-orange-600 font-semibold mb-4">No Show Booking</h2>
                            {renderRadio(
                              "no_show",
                              "Passenger(s) was no-show for the flight",
                              "Raise amendment after 24 hours of the flight’s departure time. Requests made earlier may not be processed."
                            )}
                          </div>
                        )}

                        {/* MISCELLANEOUS */}
                        {(requestType === '16' || requestType === '19') && (
                          <div className="border rounded-md p-2">
                            <h2 className="text-orange-600 font-semibold mb-2">Miscellaneous/Correction</h2>
                            <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
                              {renderRadio(
                                "PASSPORT",
                                "Passport",
                                "Correct or update passport details (e.g., new passport number, typo in old number)."
                              )}
                              {renderRadio(
                                "NAME_CHANGE",
                                "Name Change",
                                "Fix minor name issues (e.g., Samual → Samuel). Major changes not allowed."
                              )}
                              {renderRadio(
                                "TITLE_CHANGE",
                                "Title Change",
                                "Correct title prefix (e.g., Mr → Ms) if entered incorrectly."
                              )}
                              {renderRadio(
                                "DOB_UPDATION",
                                "DOB Updation",
                                "Update 'Date of Birth' if it was entered incorrectly during booking."
                              )}
                              {renderRadio(
                                "OTHERS",
                                "Others",
                                "PLEASE USE THIS OPTION ONLY IF THE REQURED SERVICE IS NOT LISTED ABOVE. For other corrections (e.g., nationality, gender), mention details in remarks. Our agents may take 2- 4 business days to respond to queries."
                              )}
                            </div>
                          </div>
                        )}
                        {/* SSR */}
                        {requestType === '11' && (
                          <div className="border rounded-md p-2">
                            <h2 className="text-orange-600 font-semibold mb-2">SSR</h2>
                            <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
                              {renderRadio(
                                "SEAT",
                                "SEAT",
                                "Add a seat as per your convenience and travel comfortably."
                              )}
                              {renderRadio(
                                "MEAL",
                                "MEAL",
                                "Pre-book the meal service of your choice."
                              )}
                              {renderRadio(
                                "BAGGAGE",
                                "BAGGAGE",
                                "Add luggage over and above the fare policy. (e.g., 15kg extra)."
                              )}
                              {renderRadio(
                                "Wheelchair",
                                "Wheelchair",
                                "Add wheelchair assistance service."
                              )}
                            </div>
                          </div>
                        )}

                        {/* Other Reason */}
                        {(requestType === '8' || requestType === '7' || requestType === '17') && (
                          <div className="border rounded-md p-2">
                            <h2 className="text-orange-600 font-semibold mb-2">Other Reason</h2>
                            <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
                              {renderRadio(
                                "medically_unfit",
                                "Passenger is medically unfit for travel",
                                "Cancel due to illness or medical emergency, attach medical proof/Death Certificate. (As per airline approval)"
                              )}
                              {renderRadio(
                                "bereavement",
                                "Unable to travel due to personal loss or bereavement",
                                "Family bereavement or serious personal emergency: supporting proof required."
                              )}
                              {renderRadio(
                                "empowerment_policy",
                                "Refund under airline empowerment policy",
                                "Airline has approved refund beyond standard rules. Dependent on Airline Policy. Ex Booked another flight of the same airline on the same date."
                              )}
                            </div>
                          </div>
                        )}
                      </div>

                      {/* Upload More Documents Section */}
                      {requestType === '19' && (
                        <div className="mb-2 mt-2">
                          <h3 className="text-base font-bold text-slate-800 mb-3">
                            Upload relevant Document <span className="text-red-500">*</span>
                          </h3>
                          <div
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDrop}
                            onClick={() => fileInputRef.current.click()}
                            className={`flex items-center justify-center w-full h-20 border-2 border-dashed rounded-xl cursor-pointer transition ${isDragging
                              ? "border-orange-500 bg-orange-50/30"
                              : "border-slate-200 hover:bg-slate-50/50"
                              }`}
                          >
                            <input
                              ref={fileInputRef}
                              type="file"
                              accept="image/jpeg,image/png,image/webp,application/pdf"
                              onChange={handleFileChange}
                              className="hidden"
                            />
                            <span className="text-xs sm:text-sm text-slate-500 text-center px-4">
                              Drag & Drop your files or{" "}
                              <span className="font-bold text-slate-800 underline underline-offset-2">
                                Browse
                              </span>
                              <span className="block text-[11px] text-slate-400 mt-0.5">
                                Supported formats: JPG, PNG, WEBP, PDF
                              </span>
                            </span>
                          </div>

                          {/* Selected Queue Files */}
                          {selectedFiles.length > 0 && (
                            <div className="mt-3 space-y-2">
                              <p className="text-xs font-semibold text-slate-500">Ready to upload:</p>
                              <div className="flex flex-wrap gap-2 max-h-24 overflow-y-auto">
                                {selectedFiles.map((file, idx) => (
                                  <div
                                    key={idx}
                                    className="flex items-center gap-1.5 bg-orange-50 border border-orange-200 text-orange-800 px-2.5 py-1 rounded-lg text-xs"
                                  >
                                    <span className="max-w-[150px] truncate">{file.name}</span>
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        removeSelectedFile(idx);
                                      }}
                                      className="text-orange-600 hover:text-orange-900"
                                    >
                                      <Trash2 size={16} />
                                    </button>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                      <div className="text-right mt-4">

                        <button disabled={Processing} type='submit' savetype='1' className="bg-blue-500 text-white px-6 py-2 rounded-lg shadow hover:bg-blue-600 transition">
                          {Processing ? (
                            <span className="flex items-center">
                              <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                              </svg>
                              Processing...
                            </span>
                          ) : (
                            <>Proceed</>
                          )}
                        </button>
                      </div>
                    </div>
                  </>
                )}

                {submitbutton && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
                    <div className="bg-white rounded-md w-full max-w-xl max-h-[90vh] p-6 shadow-lg relative flex flex-col">
                      <div className="flex justify-between items-center border-b pb-2">
                        <h2 className="text-2 font-bold">Charges & Fee</h2>
                        <button className="text-2xl font-semibold" onClick={handleClose}>&times;</button>
                      </div>
                      <div className="overflow-y-auto flex-1 py-2">
                        <div className="overflow-x-auto">
                          <table className="min-w-full border  text-sm">
                            <thead className="bg-gray-100 text-gray-700">
                              <tr>
                                <th className="px-3 py-2 border">Sector/Date</th>
                                <th className="px-3 py-2 border">Total Cost</th>
                                <th className="px-3 py-2 border">Amendment Charges</th>
                                <th className="px-3 py-2 border">Refund Amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              {trips.length > 0 ? (
                                <>
                                  {trips.map((item, key) => (
                                    <tr key={key} className="border-b">
                                      <td className="px-3 py-2 border text-center font-medium">{item.src} - {item.dest}
                                        <br />
                                        {format(new Date(item.departureDate), "dd MMM, yyyy")}
                                      </td>
                                      <td className='text-right px-3 py-2 border font-medium'>{item.totalCost}</td>
                                      <td className='text-right px-3 py-2 border font-medium'>{item.amendTotalCharges}</td>
                                      <td className='text-right px-3 py-2 border font-medium'>{item.refundTotalAmount}</td>
                                    </tr>
                                  ))}

                                  <tr>
                                    <td colSpan={3} className='text-right  px-3 py-2 border font-medium'>Service Fee</td>
                                    <td className='text-right'><CurFt currency={Currncy} price={service_fee + service_gst} /></td>
                                  </tr>
                                  {/* <tr>
                                    <td colSpan={3} className='text-right  px-3 py-2 border font-medium'>Service Fee Tax</td>
                                    <td className='text-right'><CurFt currency={Currncy} price={service_gst} /></td>
                                  </tr> */}
                                  <tr>
                                    <td colSpan={3} className='text-right  px-3 py-2 border font-medium'>Total Refund</td>
                                    <td className='text-right  px-3 py-2 border font-medium'><CurFt currency={Currncy} price={refundTotalAmount - (service_fee + service_gst)} /></td>
                                  </tr>
                                </>
                              ) : (
                                <tr>
                                  <td colSpan={4}>{Message}. You can continue to submit for amendment request.</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        <div>
                          <label className="block text-sm font-medium mb-1">Remarks</label>
                          <textarea
                            onChange={handleChangeRemarks}
                            autoComplete="Remarks"
                            id="Remarks"
                            type="text"
                            name="Remarks"
                            className="w-full border rounded-lg px-3 py-2"
                          />
                        </div>
                      </div>
                      {/* Submit Button */}
                      <div className="text-center pt-2">
                        <button disabled={Processing} savetype='2' type='submit' className="bg-blue-500 text-white px-6 py-2 rounded-lg shadow hover:bg-blue-600 transition">
                          {Processing ? (
                            <span className="flex items-center">
                              <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                              </svg>
                              Processing...
                            </span>
                          ) : (
                            <>Submit</>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </form>
          </div>



        </div>
      )
      }
    </>
  );
}

// Stepper component
const Step = ({ icon, title, subtitle, active }) => (
  <div className="flex items-center flex-1">
    <div
      className={`flex items-center justify-center w-10 h-10 rounded-full flex-shrink-0 ${active ? "bg-blue-500 text-white" : "bg-gray-200 text-gray-500"
        }`}
    >
      {icon}
    </div>
    <div className="ml-2">
      <p
        className={`text-mb ${active ? "font-bold text-blue-500" : "text-gray-600"
          }`}
      >
        {title}
      </p>
      <span className={`text-mb ${active ? "text-blue-500" : "text-mb text-gray-400"}`}>{subtitle}</span>
    </div>
  </div>
);
